import request from "@/plugins/axios";
import { InvoiceType } from "@/service/enum";
import { CacheService } from "../service/common";
import Vue from "vue";

export default {
  invoiceTaxInfo: null,
  // 开票申请列表
  getFeeApplyList(page, pageSize, invoiceNo) {
    const url = `Opencloud/InvoiceManagement/SelectMakeInvoiceOrderPageList?makeInvoiceNo=${invoiceNo}&pageIndex=${page}&pageSize=${pageSize}`;
    return request.get(url);
  },
  // 开票申请列表详情
  getFeeApplyDetailList(page, pageSize, orderId) {
    const url = `Opencloud/InvoiceManagement/SelectMakeInvoiceDetailPageList?orderId=${orderId}&pageIndex=${page}&pageSize=${pageSize}`;
    return request.get(url);
  },
  // 未开票订单列表
  getUnInvoiceOrderList(pageIndex, pageSize, orderNo, buyCompId) {
    const { compId } = CacheService.get("comp");
    const params = { pageIndex, pageSize, orderNo, saleCompId: compId, buyCompId };
    const url = `Opencloud/InvoiceManagement/SelectPayOrderNoMakePageList`;
    return request.get(url, { params });
  },
  // 根据服务商企业ID 查询当前服务商的发票配置信息(初始化查询)
  async getInvoiceTaxInfo() {
    if (!this.invoiceTaxInfo) {
      const { compId } = CacheService.get("comp");
      const url = `Opencloud/InvoiceManagement/SelectInvoiceSettingData?compId=${compId}`;
      const res = await request.get(url);
      if (res) {
        res.invoiceTypeLabel = InvoiceType[res.invoiceType];
        this.invoiceTaxInfo = res;
      }
    }
    return this.invoiceTaxInfo;
  },
  // 保存企业发票开票基础信息(增加，修改)
  saveInvoiceTaxInfo(params) {
    const url = `Opencloud/InvoiceManagement/SaveInvoiceManagementData`;
    return request.post(url, params);
  },

  // 保存申请开票
  saveInvoiceApply(params) {
    const url = `Opencloud/InvoiceManagement/SaveMakeInvoiceApplyData`;
    return request.post(url, params);
  },
  
  // 保存申请开票
  cancelInvoiceApply(makeInvoiceId, orderId = "") {
    const url = `/Opencloud/InvoiceManagement/CancleMakeInvoiceApplyData?makeInvoiceId=${makeInvoiceId}&orderId=${orderId}`;
    return request.get(url);
  },

  // 交易开票申请分页列表
  getOrderInvoiceList(page, pageSize, invoiceTitle) {
    const { compId } = CacheService.get("comp");
    const url = `Opencloud/InvoiceManagement/SelectInvoiceApplyoPageList`;
    const params = { compId, invoiceTitle, pageSize, pageIndex: page };
    return request.get(url, { params });
  },

  // 更改交易开票状态  （待处理，开票完成，开票中）
  modifyOrderInvoiceState(params) {
    const url = `Opencloud/InvoiceManagement/ModifyInvoiceApplyoPageList`;
    return request.post(url, params);
  },

  // 导出交易发票列表表格
  async exportOrderInvoiceList(page, pageSize, invoiceTitle) {
    const { compId } = CacheService.get("comp");
    const url = `Opencloud/InvoiceManagement/ImportInvoiceApplyoList?compId=${compId}&invoiceTitle=${invoiceTitle}&pageIndex=${page}&pageSize=${pageSize}`;
    await request.get(url);
  },
};
